module.exports = __webpack_public_path__ + "media/images/illustrations/twinkle_stars_small-36fcddaf1c0e763c189baf22e16747f6.svg";